import { parseDate, today } from '@internationalized/date'
import moment from 'moment-timezone'

export const getDefaultDate = (availableTimes: string[], timezone: string) => {
	const now = moment().tz(timezone)

	for (const slot of availableTimes) {
		const date = moment(slot).tz(timezone)
		if (date.isSameOrAfter(now)) {
			return parseDate(date.format('YYYY-MM-DD'))
		}
	}
	return today(timezone)
}
